<dl class="utrecht-data-list utrecht-data-list--html-dl utrecht-data-list--rows">
  {% ctx.util.eachComponent(ctx.components, function(component) { %}
    {% if (ctx.isVisibleInRow(component)) { %}
      <div class="utrecht-data-list__item">
        <dt class="utrecht-data-list__item-key">{{ component.label }}</dt>
        <dd class="utrecht-data-list__item-value utrecht-data-list__item-value--html-dd">
          {{ ctx.getView(component, ctx.row[component.key]) }}
        </dd>
      </div>
    {% } %}
  {% }) %}
</dl>

{% if (!ctx.self.options.readOnly) { %}
  <p class="utrecht-button-group utrecht-button-group--openforms-editgrid" role="group">
    <button class="utrecht-button utrecht-button--secondary-action editRow">
      <i class="{{ ctx.iconClass('edit') }}"></i>
    </button>
    {% if (!ctx.component.disableAddingRemovingRows) { %}
    <button class="utrecht-button utrecht-button--primary-action utrecht-button--danger removeRow">
      <i class="{{ ctx.iconClass('trash-can') }}"></i>
    </button>
    {% } %}
  </p>
{% } %}
